import cn from 'classnames'

import './styles.scss'

const Header = (props: React.HTMLAttributes<HTMLHeadingElement>) => {
  return <h1 {...props} className={cn('page-header', props.className)}></h1>
}

export default Header
